<template>
  <AuthFormWrapper>
    <template v-if="passwordReset">
      <div class="text-center">
        <p>Your password has been saved. You can now sign in using your new password.</p>

        <RouterLink
          class="link mt-5"
          :to="{ name: 'app_auth_login' }"
        >
          <FontAwesomeIcon :icon="faChevronLeft" />
          Back to Sign in
        </RouterLink>
      </div>
    </template>

    <template v-else>
      <p class="text-center">
        Please set your new password
      </p>

      <ResetPasswordForm @password-reset="passwordReset = true" />
    </template>
  </AuthFormWrapper>
</template>

<script setup>
import { ref } from 'vue';
import { useRoute } from 'vue-router';

import { ResetPasswordForm } from '@/components/forms';
import { AuthFormWrapper } from '@/components/wrappers';

import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const token = useRoute().query.token;
const error = ref(null);
const passwordReset = ref(false); // TODO: rename this variable to something better

if (!token) {
  error.value = 'This password reset link is either invalid or has expired.';
}
</script>
